export type EventFile = {
  id: string
  nombre?: string
  url: string
};

export type AdminDocRequestTemplateForm = {
  nombre: string
  descripcion?: string
  requerido?: boolean
};

export type DocRequestTemplateProps = {
  plantillaId: number
  nombre: string
  descripcion?: string
  categoria: DocRequestTemplateCategoryType
  requerido: boolean
  activo: boolean
};

export enum DocRequestTemplateCategoryType {
  'physical' = 'FISICA',
  'fiscal' = 'FISCAL',
  'investments' = 'INVERSIONES',
  'titular' = 'TITULARIDAD',
}
